import { getCookie } from '@javascript/utils/helper-methods'
const timeToShowPopup = 871000

export default {
  data() {
    return {
      _timer: null,
      isShow: false,
    }
  },
  methods: {
    showModal() {
      const cookieTime = getCookie('session_time_popup')
      if (cookieTime) {
        let msDifference = Date.now() - cookieTime
        if (msDifference > timeToShowPopup) {
          this.isShow = true
        } else {
          this._startTimer(msDifference)
        }
      }
    },
    hideModal() {
      this.isShow = false
      location.reload()
    },
    _startTimer(time) {
      this._timer = setTimeout(() => {
        this.showModal()
      }, time) //867000
    },

    _deleteTimer() {
      clearTimeout(this._timer)
      this._timer = 0
    },
    timeToEnd() {
      const time = getCookie('session_time_popup')
      const sum = +time + timeToShowPopup
      if ((sum - Date.now()) / 1000 > 30) {
        this.isShow = false
      }
      return sum
    },
  },
  created() {
    // document.cookie = `session_time_popup=${Date.now()}; path=/`
    document.cookie = `session_time_popup=${Date.now()}; path=/; SameSite=None; Secure`
    this._startTimer(timeToShowPopup)
  },
  updated() {
    this._deleteTimer()
    this._startTimer(timeToShowPopup)
  },
}
